module.exports = __webpack_public_path__ + "img/match6.6bc34c86.jpg";